import { userLinked } from "./constans";
import { defineAbilitiesForRoles } from "@/lib/auth/ability";
import { getAccountAccess } from "@/lib/auth/accountAccess";

export interface SessionRoute {
  label: string;
  name: string;
  route: string;
  path: string;
  icon: string;
}

type RouteUser = {
  role?: string;
  roles?: string[];
  tokenDecode?: {
    roles?: string[];
    accountType?: string;
    accountRoles?: string[];
  };
};

export function validateRoutes(user?: RouteUser | null): SessionRoute[] {
  const role = user?.role;
  const roles = [
    ...(user?.tokenDecode?.roles || []),
    ...(user?.roles || []),
  ];
  const isSupplier = roles.includes("ROLE_SUPPLIER");
  const isSapLinked = user?.tokenDecode?.accountType === userLinked;

  const accountRoles = user?.tokenDecode?.accountRoles || [];
  const ability = defineAbilitiesForRoles(
    [...new Set([...(role ? [role] : []), ...roles])],
    [...new Set(accountRoles)],
  );
  // Accesos por rol de cuenta: misma fuente que middleware.ts y ability.ts.
  const accountAccess = getAccountAccess([...new Set(accountRoles)]);
  const isAccountAdmin = accountRoles.includes("ACCOUNT_ADMIN");

  if (ability.can("access", "AdminPanel")) {
    return [
      {
        label: "Panel de administración",
        name: "Panel de administración",
        route: "/admin",
        path: "/admin",
        icon: "LayoutDashboard",
      },
    ];
  }

  const routes: SessionRoute[] = [
    {
      label: "Mi cuenta",
      name: "Mi cuenta",
      route: "/usuario",
      path: "/usuario",
      icon: "UserPen",
    },
  ];

  if (isSupplier) {
    routes[0] = {
      ...routes[0],
      label: "Mi perfil",
      name: "Mi perfil",
    };

    routes.push({
      label: "Mis marcas",
      name: "Mis marcas",
      route: "/usuario/marcas",
      path: "/usuario/marcas",
      icon: "Tags",
    });

    routes.push({
      label: "Listas de precios",
      name: "Listas de precios",
      route: "/usuario/listas-precios",
      path: "/usuario/listas-precios",
      icon: "FileSpreadsheet",
    });

    return routes;
  }
  routes.push({
    label: "Datos comerciales",
    name: "Datos comerciales",
    route: "/usuario/datos-comerciales",
    path: "/usuario/datos-comerciales",
    icon: "UsersRound",
  });

  // Sin acceso al área de cuenta (solo Visualizador) se queda en Mi cuenta y
  // Datos comerciales.
  if (!accountAccess.accountArea) {
    return routes;
  }

  routes.push(
    {
      label: "Perfil fiscal",
      name: "Perfil fiscal",
      route: "/usuario/perfil-fiscal",
      path: "/usuario/perfil-fiscal",
      icon: "DoorClosed",
    },
    {
      label: "Direcciones",
      name: "Direcciones",
      route: "/usuario/direcciones",
      path: "/usuario/direcciones",
      icon: "Hotel",
    },
  );

  if (accountAccess.billing) {
    routes.push(
      {
        label: "Facturas",
        name: "Facturas",
        route: "/usuario/facturacion/facturas",
        path: "/usuario/facturacion/facturas",
        icon: "FileText",
      },
      {
        label: "Facturas de anticipo",
        name: "Facturas de anticipo",
        route: "/usuario/facturacion/facturas-anticipo",
        path: "/usuario/facturacion/facturas-anticipo",
        icon: "Coins",
      },
      {
        label: "Notas de crédito",
        name: "Notas de crédito",
        route: "/usuario/facturacion/notas-de-credito",
        path: "/usuario/facturacion/notas-de-credito",
        icon: "Receipt",
      },
      {
        label: "Mis pagos",
        name: "Mis pagos",
        route: "/usuario/facturacion/pagos",
        path: "/usuario/facturacion/pagos",
        icon: "CreditCard",
      },
    );
  }

  routes.push(
    {
      label: "Mis favoritos",
      name: "Mis favoritos",
      route: "/usuario/favoritos",
      path: "/usuario/favoritos",
      icon: "Star",
    },
    {
      label: "Mis pedidos web",
      name: "Mis pedidos web",
      route: "/usuario/pedidos",
      path: "/usuario/pedidos",
      icon: "ShoppingCart",
    },
    {
      label: "Números de cuenta",
      name: "Números de cuenta",
      route: "/carrito/cuentas-bancarias",
      path: "/carrito/cuentas-bancarias",
      icon: "Landmark",
    },
  );

  if (accountAccess.userManagement) {
    routes.push({
      label: "Gestión de usuarios",
      name: "Gestión de usuarios",
      route: "/usuario/gestion-usuarios",
      path: "/usuario/gestion-usuarios",
      icon: "UserCog",
    });
  }

  if (isSapLinked || isAccountAdmin) {
    routes.push({
      label: "Listas de precios",
      name: "Listas de precios",
      route: "/usuario/listas-precios",
      path: "/usuario/listas-precios",
      icon: "FileSpreadsheet",
    });
  }

  return routes;
}
